import { size, omit } from 'lodash';
import { REACT_APP_BUILD_NUMBER } from '../../config';
import { activitiesTabTableId } from '../components/ActivitiesTab/ActivitiesTab';
import { sessionsTabTableId } from '../../screens/ChargerDetails/components/ChargingSessionsTab';
import { faultsSSPId } from '../../screens/ChargerDetails/components/FaultsTab';
import { chargersInfoTableId } from '../../screens/ChargersList/components/ChargersList';
import { multiFwUpdateTableId } from '../../screens/MultiFwUpdate/constants';
import { taskSSPId } from '../components/ChargerTasksSSPList/component';

const appStorePrefix = 'i2p2_app_store_';
const STORE_KEY = appStorePrefix + (REACT_APP_BUILD_NUMBER || '');
const pathsToExcludeFromSaving = [
  'dashboard.chargers',
  'dashboard.filteredChargers',
  'reports.powerMonitoring.chargerMetrics',
  'plazaView.viewingNode',
  'plazaView.userSettings',
  'plazaView.zoom',
  'plazaView.schemaParams',
  'plazaTopology',
  'alert',
  'confirm',
  'fwPackages',
  'ssoAccounts',
  'chargerTelemetry',
  'telemetryReports.powerMonitoring.chargerMetrics',
  `ssplists.${taskSSPId}.isFetching`,
  `ssplists.${activitiesTabTableId}.isFetching`,
  `ssplists.${sessionsTabTableId}.isFetching`,
  `ssplists.${faultsSSPId}.isFetching`,
  `ssplists.${chargersInfoTableId}.isFetching`,
  `ssplists.${multiFwUpdateTableId}.isFetching`,
  `ssplists.${taskSSPId}.data`,
  `ssplists.${activitiesTabTableId}.data`,
  `ssplists.${sessionsTabTableId}.data`,
  `ssplists.${faultsSSPId}.data`,
  `ssplists.${chargersInfoTableId}.data`,
  `ssplists.${multiFwUpdateTableId}.data`,
  'plazaGraphs',
  'plazaReport',
];

const clearOldStores = () => {
  const allStorageKeys = Object.keys(localStorage);

  if (size(allStorageKeys)) {
    for (const key of allStorageKeys) {
      if (key.includes(appStorePrefix) && key !== STORE_KEY) {
        localStorage.removeItem(key);
      }
    }
  }
};

export const loadStore = () => {
  try {
    const state = localStorage.getItem(STORE_KEY);

    clearOldStores();

    return JSON.parse(state) || {};
  } catch (err) {
    return undefined;
  }
};

export const saveStore = (state) => {
  try {
    const serialized = JSON.stringify(omit(state, pathsToExcludeFromSaving));

    localStorage.setItem(STORE_KEY, serialized);
  } catch (err) {
    console.error(err);
  }
};
